// src/utils/statusStyles.js

export function getStatusColor(id) {
    const map = {
        1: 'bg-blue-100',
        3: 'bg-yellow-100',
        4: 'bg-orange-100',
        5: 'bg-green-100',
        6: 'bg-red-100',
        7: 'bg-rose-100',
        8: 'bg-cyan-100',
        9: 'bg-teal-100',
        10: 'bg-rose-100',
        12: 'bg-cyan-100',
        13: 'bg-gray-200',
        14: 'bg-purple-100',
        15: 'bg-emerald-100',
        16: 'bg-rose-100',
        17: 'bg-indigo-100',
        18: 'bg-violet-100',
        19: 'bg-sky-100',
        20: 'bg-rose-100',
    };
    return map[id] || 'bg-gray-100';
}

export function getStatusTextColor(id) {
    const map = {
        1: 'text-blue-700',
        3: 'text-yellow-700',
        4: 'text-orange-700',
        5: 'text-green-700',
        6: 'text-red-700',
        7: 'text-purple-700',
        8: 'text-cyan-700',
        9: 'text-teal-700',
        10: 'text-rose-700',
        12: 'text-cyan-700',
        13: 'text-slate-700',
        14: 'text-purple-700',
        15: 'text-emerald-700',
        16: 'text-rose-700',
        17: 'text-indigo-700',
        18: 'text-violet-700',
        19: 'text-sky-700',
        20: 'text-rose-700',
    };
    return map[id] || 'text-gray-700';
}

export function getStatusIcon(id) {
    const map = {
        1: '🆕',
        3: '⏳',
        4: '🔧',
        5: '✅',
        6: '❌',
        7: '📋',
        8: '🔍',
        9: '🥇',
        10: '🚫',
        12: '🙋',
        13: '⏸️',
        14: '🧐',
        15: '👌',
        16: '🛑',
        17: '🚀',
        18: '📦',
        19: '🧪',
        20: '🛑',
    };
    return map[id] || '📌';
}

export function getStatusLabel(id, defaultName) {
    const map = {
        8: "Testing",
        9: "Testing Approved",
        10: "Testing Rejected",
        12: "Pending (Cust)",
        13: "On Hold",
        14: "Code Review Request",
        15: "Code Review Approved",
        16: "Code Review Rejected",
        17: "Production Move Request",
        18: "Production Moved",
        19: "Production Tested",
        20: "Production Rejected",
    };
    return map[id] || (defaultName === 'Reopen' ? 'Reopened' : defaultName);
}
  